import configureStore from "./configure.store";

const store = configureStore();

export default store;
